import React, { useEffect, useState } from 'react';
import Popup from './Popup';
import { getItem } from 'utils/local-storage';
import useSaveLead from 'hooks/useSaveLead';
import { ACCESS_TOKEN, USER_PROFILE } from 'utils/storage-keys';
import axios from 'axios';
import env from 'utils/env';
import { Button, message } from 'antd';
import { useGetUserProfileApi } from 'pages/dashboard/user/useUserApi';
import GlobalStore from 'stores/globalStore';

type Props = {
  membership: string;
  siteCode: string;
  country: string;
  money: number;
  setShowPopup: (state: boolean) => void;
};

const isPhoneValid = (number: string) => {
  return  /^(\+?[0-9]{8,12})$/.test(number);
};

const UpgradePopup: React.FC<Props> = ({
  membership,
  money,
  country,
  siteCode,
  setShowPopup
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [phoneValid, setPhoneValid] = useState(true);
  const [phone, setPhone] = useState('');
  const config = env();
  const token = getItem(ACCESS_TOKEN);
  const { profileObject } = useGetUserProfileApi();
  const { entitlements } = GlobalStore.useContainer();
  const userId = entitlements?.user_id || JSON.parse(getItem(USER_PROFILE) || "{}")?.user_id || '';
  const { saveLead } = useSaveLead();

  useEffect(() => {
    if (!token || !profileObject) return;
    if (!profileObject?.data?.username) {
      message.error('請輸入你的名字');
      return setShowPopup(false);
    }
    if (!isPhoneValid(profileObject?.data?.phone)) {
      return setPhoneValid(false);
    }

    saveLead(profileObject, membership, {}, {
      site_code: siteCode,
      unused_money: money,
      session_token: token,
      is_upgrade: true,
      user_id: userId,
      country
    });
  }, [membership, money, profileObject, siteCode, token, saveLead, userId, setShowPopup, country]);

  const handleSubmitPhone = async () => {
    if (!token) return;
    if (!isPhoneValid(phone))
      return message.error('請輸入一個有效的電話號碼');
    setIsLoading(true);
    try {
      await axios.patch(
        `${config.baseApiUrl}/user/api/v1/account`,
        {
          phone
        },
        {
          headers: {
            'X-Session-Token': token
          }
        }
      );

      const newProfile = {
        ...profileObject,
        data: { ...profileObject?.data, phone }
      }
      saveLead(newProfile, membership, {}, {
        site_code: siteCode,
        unused_money: money,
        session_token: token,
        is_upgrade: true,
        user_id: userId,
        country
      });
    } catch (error) {
      message.error('Server is busy. Please try again later!');
      setIsLoading(false);
    }
  };

  return (
    <Popup>
      {phoneValid ? (
        <h2>您的要求正在處理中…</h2>
      ) : (
        <div className="form-phone">
          <h3>請添加您的電話號碼和個人信息，以便我們更方便地提供幫助</h3>
          <div className="form-input">
            <label htmlFor="phone">電話號碼</label>
            <input
              type="phone"
              name="phone"
              id="phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </div>
          <Button className="btn-primary" onClick={handleSubmitPhone} loading={isLoading}>
            立即註冊
          </Button>
          <button className="btn-white" onClick={() => setShowPopup(false)}>
            取消註冊
          </button>
        </div>
      )}
    </Popup>
  );
};

export default UpgradePopup;
